import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const WholesaleTab = () => {
  const [rows, setRows] = useState(null);

  const load = () => api.get("/wholesale").then((r) => setRows(r.data)).catch(() => toast.error("Could not load enquiries"));
  useEffect(() => { load(); }, []);

  if (!rows) return <div className="h-64 animate-pulse rounded-2xl bg-sand" />;

  return (
    <div data-testid="admin-wholesale-tab">
      <div className="mb-5 flex items-center justify-between">
        <p className="text-sm text-clay/60">{rows.length} wholesale enquiries</p>
        <button onClick={load} className="flex items-center gap-2 rounded-full border border-linen px-4 py-2 text-xs font-semibold text-clay transition-colors hover:border-terra hover:text-terra">
          <RefreshCw className="h-3.5 w-3.5" /> Refresh
        </button>
      </div>

      {rows.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-linen bg-white p-14 text-center">
          <p className="font-serif text-xl text-espresso">No wholesale enquiries yet</p>
          <p className="mt-2 text-sm text-clay/60">Enquiries from the /wholesale page land here, with an email notification to you.</p>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-linen bg-white" data-testid="admin-wholesale-table">
          <table className="w-full min-w-[820px] text-left text-sm">
            <thead>
              <tr className="border-b border-linen font-mono text-[10px] uppercase tracking-[0.18em] text-clay/60">
                <th className="px-5 py-3.5">Enquiry</th>
                <th className="px-5 py-3.5">Contact</th>
                <th className="px-5 py-3.5">Interested in</th>
                <th className="px-5 py-3.5">Quantity</th>
                <th className="px-5 py-3.5">Message</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-linen/70">
              {rows.map((w) => (
                <tr key={w.id} className="align-top transition-colors hover:bg-sand/40">
                  <td className="px-5 py-3.5">
                    <p className="font-mono font-semibold text-espresso">#{w.id}</p>
                    <p className="font-mono text-[10px] text-clay/50">{new Date(w.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}</p>
                  </td>
                  <td className="px-5 py-3.5">
                    <p className="font-medium text-espresso">{w.name}{w.business ? ` · ${w.business}` : ""}</p>
                    <p className="text-xs text-clay/60">{w.email}</p>
                    <p className="text-xs text-clay/60">{w.phone}</p>
                  </td>
                  <td className="px-5 py-3.5 text-clay/70">{w.interest || "—"}</td>
                  <td className="px-5 py-3.5 text-clay/70">{w.quantity || "—"}</td>
                  <td className="max-w-xs px-5 py-3.5 text-xs leading-relaxed text-clay/70">{w.message || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WholesaleTab;
